import { makeAutoObservable } from 'mobx';
import { ImporterDto, ImportTypeEnum } from '../../../../defs/api';

export class ImporterMobxDto implements ImporterDto {
    id: ImportTypeEnum | null;

    description: string;

    blacklist: string[];

    isEnabled: boolean;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: ImporterDto): ImporterMobxDto {
        const mobxDto = new ImporterMobxDto();
        return Object.assign(mobxDto, dto);
    }

    static createFromArray(dtos: ImporterDto[]): ImporterMobxDto[] {
        return dtos.map((dto) => ImporterMobxDto.create(dto));
    }
}
